import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setFilterGroup, updateFilter } from 'store/actions/search';
import { denormalizeContextFilters } from 'components/utils/helpers';
import { VIDEO_LANGUAGES } from 'components/utils/constants';
import FilterGroup from './FilterGroup';
import FilterCheckboxes from './FilterCheckboxes';

const btvBrandNames = ['BTV_short', 'BTV_long'];
const featureBrandNames = ['WebSeries', 'QuickTake', 'QuickTakeExplainers'];
const broadcastBrandNames = ['AsLive', 'Footage', 'Interviews', 'SoundBites'];

const durationOptions = [
  { name: 'shortForm', displayName: 'Shorter than 5 minutes' },
  { name: 'longForm', displayName: 'Longer than 5 minutes' },
];

const typeOptions = [
  { name: 'clean', displayName: 'Clean' },
  { name: 'dirty', displayName: 'Dirty' },
];

class VideoFilters extends Component {
  updateSearchFilters(checked, brandRefName) {
    const { subscriptions, filters } = this.props;
    const brandsForSearch = subscriptions.filter(sub => (checked && sub.refName === brandRefName) || (filters.video && filters.video[sub.refName] && sub.refName !== brandRefName));

    if (brandsForSearch.length === 0) {
      this.props.updateFilter('video', brandRefName, true);
    } else {
      const { brands } = denormalizeContextFilters({ brands: brandsForSearch.map(({ refName, name }) => ({ value: refName, displayValue: name })) });
      this.props.setFilterGroup('brands', brands);
    }
  }

  renderSubscriptionSection(labelBrandNames, subsBrands, className) {
    if (Array.isArray(subsBrands) && subsBrands.length > 0) {
      const labelBrands  = subsBrands.filter(({ refName }) => labelBrandNames.includes(refName));
      return labelBrands.map(labelBrand => ({ name: labelBrand.refName, displayName: labelBrand.name, label: labelBrand.label })).map((labelBrand, index) => <FilterCheckboxes className={className} key={`${labelBrand.refName}-${index}`} legend={index === 0 && labelBrand.label} filterKey="video" options={[labelBrand]} onClick={(checked, name) => this.updateSearchFilters(checked, name)} />);
    }
    return null;
  }

  render() {
    const { filters, subscriptions } = this.props;

    return (
      <FilterGroup className="video" name="Video" open={filters.media.video}>
        { this.renderSubscriptionSection(btvBrandNames, subscriptions, 'video-btv') }
        { this.renderSubscriptionSection(featureBrandNames, subscriptions, 'video-featured-content') }
        { this.renderSubscriptionSection(broadcastBrandNames, subscriptions, 'video-broadcast-content') }
        <FilterCheckboxes className="video-duration" legend="Duration" filterKey="video" options={durationOptions} />
        <FilterCheckboxes className="video-type" legend="Type" filterKey="video" options={typeOptions} />
        <FilterCheckboxes className="video-subtitles-language" legend="Language" filterKey="video" options={VIDEO_LANGUAGES} checkboxGroup={VIDEO_LANGUAGES.map(option => option.name)} />
      </FilterGroup>
    );
  }
}

const mapStateToProps = ({ search, user }) => ({
  subscriptions: user.user.videoBrands,
  filters: search.filters,
});

const mapDispatchToProps = {
  updateFilter,
  setFilterGroup,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoFilters);
